import { BackendConfigLanguageInterface } from 'common/data/backend/config/language.interface';
import { ConfigLanguageCodeEnum } from 'common/helper/config/language-code.enum';

export const BackendConfigLanguageDefault: BackendConfigLanguageInterface = {
  current: ConfigLanguageCodeEnum.en,
  isRtl: false,
  alternative: ConfigLanguageCodeEnum.ar,
  list: [ConfigLanguageCodeEnum.en, ConfigLanguageCodeEnum.ar],
};
